module.exports = __webpack_public_path__ + "static/img/tabletupianc2.399db58.png";